import { render, staticRenderFns } from "./ServiceTermsDetail.vue?vue&type=template&id=611d17d5&scoped=true"
import script from "./ServiceTermsDetail.vue?vue&type=script&lang=js"
export * from "./ServiceTermsDetail.vue?vue&type=script&lang=js"
import style0 from "./ServiceTermsDetail.vue?vue&type=style&index=0&id=611d17d5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "611d17d5",
  null
  
)

export default component.exports